import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

const Wood = () => {
  const { language, isRTL } = useLanguage();

  const productSlugs = [
    "home-furniture",
    "wooden-doors",
    "wooden-decorations",
    "restaurant-equipment",
    "office-furniture",
    "wall-cladding",
    "hotel-equipment",
    "furnished-apartments",
    "workspace-equipment",
    "wardrobes",
    "kitchen-cabinets"
  ];

  const content = {
    ar: {
      title: "منتجات الخشب",
      welcome: "مرحباً بكم في عالم الخشب المتميز",
      welcomeText: "نفخر بتقديم مجموعة واسعة من منتجات الخشب عالية الجودة المصممة بحرفية وإبداع لتلبية احتياجاتكم المختلفة. نستخدم أجود أنواع الأخشاب الطبيعية ونعتمد على تقنيات تصنيع متطورة لضمان منتجات تدوم طويلاً وتضيف لمسة من الفخامة والأناقة إلى مساحاتكم.",
      qualities: [
        { title: "جودة استثنائية", description: "نستخدم أفضل أنواع الأخشاب ونطبق معايير صارمة في عمليات التصنيع" },
        { title: "تصاميم عصرية", description: "نجمع بين الأصالة والحداثة في تصاميم تناسب مختلف الأذواق" },
        { title: "حلول متكاملة", description: "نقدم خدمات شاملة من التصميم إلى التصنيع والتركيب والصيانة" }
      ],
      whyChoose: "لماذا تختار منتجاتنا الخشبية؟",
      benefits: [
        { title: "مواد طبيعية", description: "نستخدم أخشاباً طبيعية 100% مستدامة من مصادر موثوقة تحافظ على البيئة وتضمن جودة المنتج النهائي." },
        { title: "صناعة حرفية", description: "يتم تصنيع منتجاتنا بأيدي حرفيين مهرة يمتلكون خبرة طويلة وشغفاً بالتفاصيل الدقيقة." },
        { title: "متانة فائقة", description: "تتميز منتجاتنا بالمتانة والقدرة على تحمل الاستخدام المستمر لسنوات طويلة دون فقدان جودتها." },
        { title: "تصاميم مخصصة", description: "نقدم خدمات التصميم المخصص لتنفيذ رؤيتكم الخاصة وتلبية متطلباتكم المحددة بدقة عالية." }
      ],
      browseProducts: "تصفح منتجاتنا الخشبية",
      viewImages: "عرض الصور",
      ctaTitle: "نحن هنا لتحقيق رؤيتكم",
      ctaText: "سواء كنتم تبحثون عن قطع أثاث فريدة أو تجهيز مشروع تجاري متكامل، فريقنا من المصممين والحرفيين مستعد لتحويل أفكاركم إلى واقع ملموس.",
      ctaButton: "تواصل معنا للاستفسار",
      products: [
        { title: "أثاث منزلي", description: "أثاث منزلي فاخر بتصميمات عصرية تجمع بين الراحة والأناقة. نقدم تشكيلة واسعة من الأرائك والطاولات وغرف النوم المصنوعة من أفخم أنواع الأخشاب الطبيعية." },
        { title: "أبواب خشبية", description: "أبواب خشبية بجودة عالية مصممة لتدوم طويلاً مع الحفاظ على جمالها. نوفر مجموعة متنوعة من الأبواب الداخلية والخارجية بتصاميم كلاسيكية وعصرية." },
        { title: "ديكورات خشبية", description: "ديكورات خشبية مميزة للمنازل تضفي لمسة أناقة على المساحات. من الرفوف الأنيقة إلى الحواجز الخشبية والأعمدة المزخرفة." },
        { title: "تجهيزات مطاعم", description: "تجهيزات خشبية للمطاعم والكافيهات تجمع بين الأناقة والمتانة. طاولات وكراسي وكاونترات وديكورات خشبية مصممة خصيصاً لتحمل الاستخدام المكثف." },
        { title: "أثاث مكتبي", description: "أثاث مكتبي خشبي عملي وأنيق يوفر بيئة عمل مريحة ومنتجة. مكاتب وكراسي وخزائن وطاولات اجتماعات مصممة بعناية." },
        { title: "تجليد الجدران", description: "تجليد جدران خشبي بتصميمات فاخرة يمنح المساحات طابعاً مميزاً من الدفء والفخامة." },
        { title: "تجهيز فنادق", description: "تجهيزات خشبية متكاملة للفنادق تجمع بين الفخامة والمتانة. من أثاث الغرف إلى ديكورات الاستقبال والمطاعم." },
        { title: "تجهيز شقق مفروشة", description: "أثاث خشبي للشقق المفروشة بأعلى جودة يجمع بين الأناقة والعملية." },
        { title: "تجهيز مساحات العمل", description: "تجهيزات خشبية مخصصة لمساحات العمل المشتركة تجمع بين الوظيفة والجمالية." },
        { title: "خزائن الملابس", description: "خزائن ملابس خشبية بتصاميم عصرية وتقسيمات داخلية مدروسة توفر أقصى استفادة من المساحة." },
        { title: "خزائن المطبخ", description: "خزائن مطبخ خشبية تجمع بين الجودة العالية والتصميم العملي." }
      ]
    },
    en: {
      title: "Wood Products",
      welcome: "Welcome to the World of Premium Wood",
      welcomeText: "We are proud to offer a wide range of high-quality wood products designed with craftsmanship and creativity to meet your various needs. We use the finest natural woods and rely on advanced manufacturing techniques to ensure products that last long and add a touch of luxury and elegance to your spaces.",
      qualities: [
        { title: "Exceptional Quality", description: "We use the best types of wood and apply strict standards in manufacturing processes" },
        { title: "Modern Designs", description: "We combine authenticity and modernity in designs that suit different tastes" },
        { title: "Complete Solutions", description: "We offer comprehensive services from design to manufacturing, installation, and maintenance" }
      ],
      whyChoose: "Why Choose Our Wood Products?",
      benefits: [
        { title: "Natural Materials", description: "We use 100% natural sustainable wood from reliable sources that preserve the environment and ensure final product quality." },
        { title: "Craftsmanship", description: "Our products are manufactured by skilled craftsmen with long experience and passion for fine details." },
        { title: "Superior Durability", description: "Our products feature durability and the ability to withstand continuous use for many years without losing quality." },
        { title: "Custom Designs", description: "We offer custom design services to execute your vision and meet your specific requirements with high precision." }
      ],
      browseProducts: "Browse Our Wood Products",
      viewImages: "View Images",
      ctaTitle: "We Are Here to Realize Your Vision",
      ctaText: "Whether you are looking for unique furniture pieces or complete commercial project equipment, our team of designers and craftsmen is ready to turn your ideas into reality.",
      ctaButton: "Contact Us for Inquiries",
      products: [
        { title: "Home Furniture", description: "Luxury home furniture with modern designs combining comfort and elegance. We offer a wide selection of sofas, tables, and bedrooms made from the finest natural woods." },
        { title: "Wooden Doors", description: "High-quality wooden doors designed to last long while maintaining their beauty. We provide a variety of interior and exterior doors with classic and modern designs." },
        { title: "Wooden Decorations", description: "Distinctive wooden decorations for homes adding a touch of elegance to spaces. From elegant shelves to wooden partitions and decorated columns." },
        { title: "Restaurant Equipment", description: "Wooden equipment for restaurants and cafes combining elegance and durability. Tables, chairs, counters, and wooden decorations specially designed to withstand intensive use." },
        { title: "Office Furniture", description: "Practical and elegant wooden office furniture providing a comfortable and productive work environment. Desks, chairs, cabinets, and meeting tables carefully designed." },
        { title: "Wall Cladding", description: "Luxury wooden wall cladding giving spaces a distinctive character of warmth and luxury." },
        { title: "Hotel Equipment", description: "Complete wooden equipment for hotels combining luxury and durability. From room furniture to reception and restaurant decorations." },
        { title: "Furnished Apartments", description: "High-quality wooden furniture for furnished apartments combining elegance and practicality." },
        { title: "Workspace Equipment", description: "Custom wooden equipment for shared workspaces combining function and aesthetics." },
        { title: "Wardrobes", description: "Modern wooden wardrobes with thoughtful internal divisions providing maximum space utilization." },
        { title: "Kitchen Cabinets", description: "Wooden kitchen cabinets combining high quality and practical design." }
      ]
    }
  };

  const t = content[language];

  const productImages = [
    "/lovable-uploads/f880eff4-fd91-451b-a6e6-3d0c6fabe56f.png",
    "/lovable-uploads/446e75d8-cedf-4868-b00d-34f03c736054.png",
    "/lovable-uploads/c50756ad-e98d-4976-b622-c35dc59fa0d6.png",
    "/lovable-uploads/fd7f9037-362e-47cd-868b-d7dca218fa60.png",
    "/lovable-uploads/office-furniture.jpg",
    "/lovable-uploads/56f722da-bf52-4267-86b5-91b9db704f2b.png",
    "/lovable-uploads/b007d6ed-6308-4e65-9c92-d100b12861ff.png",
    "/lovable-uploads/e97f392b-3dca-4d61-ab66-742676bbbdc5.png",
    "/lovable-uploads/6f61eeea-613a-4d0f-93ea-337425960036.png",
    "/lovable-uploads/61e6df14-89e7-4f12-a903-8761e6ddc560.png",
    "/lovable-uploads/435dc714-885d-4a20-99a7-01faffd3c1ad.png"
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-12" dir={isRTL ? "rtl" : "ltr"}>
      <Navbar />
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-kufi font-bold text-center mb-6 text-primary">{t.title}</h1>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white rounded-lg shadow-md p-6 mb-12 text-center"
        >
          <h2 className="text-2xl font-kufi font-bold mb-4 text-wood">{t.welcome}</h2>
          <p className="text-gray-700 mb-6 leading-relaxed max-w-4xl mx-auto">
            {t.welcomeText}
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
            {t.qualities.map((quality, index) => (
              <div key={index} className="bg-muted p-4 rounded-md">
                <h3 className="font-bold text-wood font-kufi mb-2">{quality.title}</h3>
                <p className="text-sm">{quality.description}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-wood/5 rounded-lg p-6 mb-12"
        >
          <h2 className="text-2xl font-kufi font-bold text-center mb-6 text-wood">{t.whyChoose}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {t.benefits.map((benefit, index) => (
              <div key={index} className="bg-white p-5 rounded-lg shadow-sm">
                <h3 className="font-bold text-lg mb-2 text-wood font-kufi">{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </motion.div>

        <h2 className="text-2xl font-kufi font-bold text-center mb-8 text-wood">{t.browseProducts}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.products.map((product, index) => (
            <motion.div
              key={product.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <Card className="overflow-hidden hover:shadow-lg transition-shadow duration-300 h-full flex flex-col">
                <img
                  src={productImages[index]}
                  alt={product.title}
                  className="w-full h-48 object-cover"
                />
                <CardContent className="p-6 flex-grow flex flex-col">
                  <h3 className="text-xl font-kufi font-bold mb-2 text-wood">{product.title}</h3>
                  <p className="text-gray-600 mb-4 flex-grow">{product.description}</p>
                  <Link to={productSlugs[index] === "kitchen-cabinets" ? "/kitchen-cabinets" : `/wood/${productSlugs[index]}`}>
                    <Button className="bg-wood hover:bg-wood/90 w-full mt-auto">
                      {t.viewImages}
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center mt-16 bg-wood/10 p-8 rounded-lg"
        >
          <h2 className="text-2xl font-kufi font-bold mb-4 text-wood">{t.ctaTitle}</h2>
          <p className="max-w-2xl mx-auto mb-6">
            {t.ctaText}
          </p>
          <Button className="bg-wood hover:bg-wood/90 text-white font-kufi py-2 px-6 rounded-md">
            {t.ctaButton}
          </Button>
        </motion.div>
      </div>
      <Footer />
    </div>
  );
};

export default Wood;
